import Model from '../Model'

export default class DocumentsType extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/dictionary/documents-types'
    }
}
